import React, { useRef, useState, useEffect, forwardRef, createRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import classes from "./UploadLessonPlan.module.css";
import { LessonContentTypeEnumText } from '../../../../models/LessonContentTypeEnum'
import { lessonsApi } from '../../../../utils';
import Loader from "../../../UI/Loader";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import fileImport from '../../../../assests/lesson/insert-drive-file.svg';
import addFiles from '../../../../assests/lesson/addFiles.svg';
import deleteIcon from '../../../../assests/lesson/reflection/delete.png';
import UploadAuxiliaryPopup from "./UploadAuxiliaryPopup/UploadAuxiliaryPopup";
import DynamicMessage from "../../../lms-shared/UI/Popups/DynamicMessage/DynamicMessage";
import { checkLinkFileExtension, DynamicFileThumbnail } from "../../../lms-shared/functions/DynamicFileThumbnail";
import { AttachmentTypeEnumText } from "../../../lms-shared/models/AttachmentTypeEnum";
import FilesPopup from "../../../lms-shared/UI/Popups/FilesPopup/FilesPopup";
import { DynamicMessageTypeEnum } from "../../../lms-shared/models/DynamicMessageTypeEnum";

const UploadLessonPlan = forwardRef(({ id, setLesson, planContentPath, planContentType, contentData, filesBaseUrl }, reactRef) => {

    const dispatch = useDispatch()
    const ref = useRef();
    const descriptionsRef = useRef([]);
    const texts = useSelector(state => state.translate.texts);
    const [load, setLoad] = useState(false);
    const [deleteMessage, setDeleteMessage] = useState(false);
    const [deleteAttachments, setDeleteAttachments] = useState(false);
    const [uploadFilesPopup, setUploadFilesPopup] = useState(false);
    const [filesPopup, setFilesPopup] = useState()

    useEffect(() => {
        setLoad(false)
    }, [])


    useEffect(() => {
        descriptionsRef.current = descriptionsRef.current.slice(0, contentData?.Attachments.length);
        descriptionsRef?.current.forEach((itemRef,) => {
            if (itemRef) {
                const element = itemRef;
                const arRegex = /[\u0600-\u06FF\u0750-\u077F]/;
                const heRegex = /[\u0590-\u05FF]/
                if (heRegex.test(element.textContent) || arRegex.test(element.textContent)) {
                    element.style.direction = 'rtl';
                }
            }
        });
    }, [contentData]);

    const fileType = {
        'pdf': "PDF",
        'pptx': "PowerPointOpenXML"
    };
    const fileTypeSrc = {
        'PDF': '',
        'PowerPointOpenXML': `https://view.officeapps.live.com/op/embed.aspx?embedded=true&src=`
    };

    function handleFileReader(e) {
        setLoad(true)
        const ext = e.target.files[0].name.split('.').pop();

        if (!fileType[ext]) {
            alert(`can only upload ${fileType} files`)
            setLoad(false)
        }
        else {
            fetchAddFile(e, LessonContentTypeEnumText.Plan, ext)
        }
    }

    const handleAuxiliaryFileReader = (e, url) => {
        setLoad(true)
        const ext = !url ? e.target.files[0]?.name.split('.').pop() : null;
        fetchAddFile(e, LessonContentTypeEnumText.Attachment, ext, url)
    }

    const fetchAddFile = (e, lessonContentType, ext, url) => {
        let myFile = !url ? e.target.files[0] : null

        const formData = {
            lessonContent: lessonContentType,
            contentType: fileType[ext],
            attachmentType: !url ? AttachmentTypeEnumText.File : AttachmentTypeEnumText.Link,
            fileDescription: !url ? myFile.name : url,
            link: url ? url : null,
            id: id,
            file: myFile
        }

        lessonsApi.lessonsAddFilePost(formData, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.lessonsAddFileError, error: error, statusCode: response?.statusCode, message: "lessonsAddFilePost " + error.message, level: 2, component: "UploadLessonPlan", line: 49 }))
            }
            else {
                if (lessonContentType === LessonContentTypeEnumText.Plan) {
                    if (resdata.planContentPath === planContentPath && ref.current) {
                        ref.current.src = ref.current.src
                    }
                    setLesson({ planContentPath: resdata.planContentPath, planContentType: fileType[ext] })
                }
                if (lessonContentType === LessonContentTypeEnumText.Attachment) {
                    setLesson({ contentData: JSON.parse(response.body.contentData), filesBaseUrl: response.body.filesBaseUrl })
                    setUploadFilesPopup(false)
                }
            }
            setLoad(false)
        })
    }

    const hundleDeleteFile = () => {
        setDeleteMessage(false)
        const body = {
            id: id,
            fileId: deleteAttachments ? deleteAttachments : undefined,
            lessonContent: deleteAttachments ? LessonContentTypeEnumText.Attachment : LessonContentTypeEnumText.Plan
        }
        lessonsApi.lessonsDeleteFilePost({ lessonDeleteFileInput: body }, (error, resdata, response) => {
            if (error) {
                deleteAttachments && setDeleteAttachments(false)
                dispatch(throwApiError({ userMessage: texts.lessonsAddFileError, error: error, statusCode: response?.statusCode, message: "lessonsAddFilePost " + error.message, level: 2, component: "UploadLessonPlan", line: 49 }))
            } else {
                if (deleteAttachments) {
                    contentData.Attachments = contentData.Attachments.filter(item => item.Id !== deleteAttachments);
                    setDeleteAttachments(false)
                }
                else
                    setLesson({ planContentPath: null, planContentType: null })
            }
        })
    }

    const openFiles = (auxiliary) => {
        if (auxiliary.Link) {
            checkLinkFileExtension(auxiliary.Link) ?
                setFilesPopup(<FilesPopup fileUrl={auxiliary.Link} title={auxiliary.Description} setMessage={setFilesPopup} />)
                : window.open(auxiliary.Link)
        }
        else {
            setFilesPopup(<FilesPopup fileUrl={`${filesBaseUrl}/${auxiliary.FileSubUrl}`} title={auxiliary.Description} setMessage={setFilesPopup} />)
        }
    }

    return (
        <div className={classes.UploadLessonPlanWrapper}>
            <div className={classes.UploadLessonPlan}>
                <h2 className={classes.Text}>{texts.Lesson}</h2>
                {!planContentPath ?
                    <div className={classes.AddFile}>
                        <div className={classes.AddFile}>
                            <div className={classes.AddFileBtn}>
                                <img src={fileImport} />
                                <p className={classes.ToUpload}>{texts.toUpload}</p>
                                <p className={classes.ApproveTypes}>{texts.approveTypes}</p>
                                <input className={classes.FileInput} onClick={(e) => e.target.value = ''} onChange={handleFileReader} type="file" accept=".pptx, application/pdf" id="FileInput" />
                            </div>
                        </div>
                    </div> :
                    <div className={classes.ShowPreview}>
                        <iframe className={classes.Iframe} title="LessonPlanView" src={`${fileTypeSrc[planContentType]}${planContentPath}?notCache=${Math.floor(new Date().getTime())}`} height="100%" width="100%" />
                    </div>}
                {planContentPath && <img className={classes.Delete} src={deleteIcon} onClick={() => setDeleteMessage(true)} />}
            </div>
            <div className={classes.UploadLessonPlan}>
                <h2 className={classes.Text}>{texts.addAuxiliary}</h2>
                <div className={classes.AuxiliaryMaterialsWrapper}>
                    <div className={classes.AddAuxiliary}>
                        <div className={classes.NewFile} onClick={() => setUploadFilesPopup(true)}>
                            <img src={addFiles} />
                        </div>
                        <p className={classes.NewFileText}>{texts.uploadNew}</p>
                    </div>
                    {contentData && contentData.Attachments && contentData.Attachments.length > 0 &&
                        <div className={classes.AuxiliaryMaterials}>
                            {contentData.Attachments.map((a, index) => {
                                const thumbnail = a.FileSubUrl ? DynamicFileThumbnail(a.FileSubUrl, filesBaseUrl) : a.Link ? DynamicFileThumbnail(a.Link) : null;
                                return <div className={classes.NewFile} key={a.Id} onClick={() => openFiles(a)}>
                                    {thumbnail && <img className={classes.AuxiliaryMaterialImg} src={thumbnail} alt={thumbnail} />}
                                    <p className={classes.AuxiliaryMaterialText} ref={el => descriptionsRef.current[index] = el}>{a.Description}</p>
                                    <div className={classes.DeleteAuxiliary}>
                                        <img className={classes.Download} src={deleteIcon} alt="deleteIcon" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setDeleteMessage(true); setDeleteAttachments(a.Id) }} />
                                    </div>
                                </div>
                            })}
                        </div>}
                </div>
            </div>
            {uploadFilesPopup && <UploadAuxiliaryPopup setClose={setUploadFilesPopup} handleAuxiliaryFileReader={handleAuxiliaryFileReader} />}
            {load && <Loader />}
            {filesPopup}
            {deleteMessage && <DynamicMessage
                type={DynamicMessageTypeEnum.Warn}
                headerText={!deleteAttachments ? texts.deleteLessonFile : texts.deleteFile}
                content={!deleteAttachments ? texts.alertDeleteLesson : texts.alertDeleteAuxiliary}
                cancelFunc={() => setDeleteMessage(null)}
                confirmFunc={hundleDeleteFile} />}
        </div>
    )
})

export default UploadLessonPlan;